import { render, staticRenderFns } from "./login-form.component.vue?vue&type=template&id=b1b63e36&"
import script from "./login-form.component.vue?vue&type=script&lang=ts&"
export * from "./login-form.component.vue?vue&type=script&lang=ts&"
import style0 from "./login-form.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "login-form.component.vue"
export default component.exports